import { defaultSwatch } from '../../data/materials';
import templates from '../../data/templates';
import { Kite, Store } from '../types';

export const defaultKiteData: Kite = {
    name: 'Default Kite',
    parts: [],
    template: 'magnet' as Kite['template'],
    svg: templates.magnet.svg,
    meta: {
        notes: '',
    },
};

export const storage_key = 'mwd-kite-colorizer';
export const initialStore: Store = {
    meta: { version: 4 },
    kites: {},
    draft: { ...defaultKiteData },
    session: {
        current: '',
        page: 'kite',
        menuOpen: true,
    },
    editor: {
        draftSaved: true,
        part: null,
        swatch: defaultSwatch,
        material: 'icarexPc31',
    },
};
